var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__Logo (1) 1",
    clipPath: "url(#clip0_12_4172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2449 12.7162C24.2449 11.9262 24.1749 11.1762 24.0549 10.4462H12.7549V14.9562H19.2249C18.9349 16.4362 18.0849 17.6862 16.8249 18.5362V21.5362H20.6849C22.9449 19.4462 24.2449 16.3662 24.2449 12.7162Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7549 24.4462C15.9949 24.4462 18.7049 23.3662 20.6849 21.5362L16.8249 18.5362C15.7449 19.2562 14.3749 19.6962 12.7549 19.6962C9.62492 19.6962 6.97492 17.5862 6.02492 14.7362H2.04492V17.8262C4.01492 21.7462 8.06492 24.4462 12.7549 24.4462Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.02488 14.7362C5.77488 14.0162 5.64488 13.2462 5.64488 12.4462C5.64488 11.6462 5.78488 10.8762 6.02488 10.1562V7.06616H2.04488C1.22488 8.68616 0.754883 10.5062 0.754883 12.4462C0.754883 14.3862 1.22488 16.2062 2.04488 17.8262L6.02488 14.7362Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7549 5.19617C14.5249 5.19617 16.1049 5.80617 17.3549 6.99617L20.7749 3.57617C18.7049 1.63617 15.9949 0.446167 12.7549 0.446167C8.06492 0.446167 4.01492 3.14617 2.04492 7.06617L6.02492 10.1562C6.97492 7.30617 9.62492 5.19617 12.7549 5.19617Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_4172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.446167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bff3658a2c4b5c75baf0b956679218bc.svg";
export { ForwardRef as ReactComponent };